export const PAGE_SECTIONS = {
  dashboard: {
    icon: 'material-symbols:dashboard',
    label: 'Dashboard',
    indexRoute: 'dashboard',
  },
  accommodations: {
    icon: 'fa-pro-solid:house',
    label: 'Unterkünfte',
    indexRoute: 'accommodations.index',
  },
  offers: {
    icon: 'fa-pro-solid:tags',
    label: 'Angebote',
    indexRoute: 'offers.index',
  },
  events: {
    icon: 'fa-pro-solid:calendar-day',
    label: 'Veranstaltungen',
    indexRoute: 'events.index',
  },
  discover: {
    icon: 'fa-pro-solid:compass',
    label: 'Entdecken',
    indexRoute: 'discover.index',
  },
  inquiries: {
    icon: 'fa-pro-solid:inbox',
    label: 'Anfragen',
    indexRoute: 'inquiries.index',
  },
  ads: {
    icon: 'fa-pro-solid:megaphone',
    label: 'Werbeanzeigen',
    indexRoute: 'ads.index',
  },
  websites: {
    icon: 'fa-pro-solid:globe',
    label: 'Websites',
    indexRoute: 'websites.index',
  },
  domains: {
    icon: 'iconoir:www',
    label: 'Domains',
    indexRoute: 'domains.index',
  },
  packages: {
    icon: 'streamline-ultimate:startup-product-rocket-box-bold',
    label: 'Pakete',
    indexRoute: 'packages.index',
  },
  organisations: {
    icon: 'fa-pro-solid:folder-tree',
    label: 'Organisationen',
    indexRoute: 'organisations.index',
  },
  media: {
    icon: 'fa-pro-solid:folders',
    label: 'Fotos / Dokumente / Videos',
    indexRoute: 'media.index',
  },
  settings: {
    icon: 'fa-pro-solid:gears',
    label: 'Einstellungen',
    indexRoute: 'account.settings',
  },
  invoices: {
    icon: 'fa-pro-solid:file-invoice-dollar',
    label: 'Rechnungen',
    indexRoute: 'account.invoices',
  },
  survey: {
    icon: 'fa-pro-solid:clipboard-list-check',
    label: 'Fragebogen',
    indexRoute: 'account.survey',
  },
  support: {
    icon: 'fa-pro-solid:comments-question',
    label: 'Support',
    indexRoute: 'account.support',
  },
}
